module.exports = __webpack_public_path__ + "img/haber-detay-header-bg.0ecf25c3.png";